import { render, staticRenderFns } from "./EditLabelModal.vue?vue&type=template&id=23b9d861&scoped=true"
import script from "./EditLabelModal.vue?vue&type=script&lang=js"
export * from "./EditLabelModal.vue?vue&type=script&lang=js"
import style0 from "./EditLabelModal.vue?vue&type=style&index=0&id=23b9d861&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9d861",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b9d861')) {
      api.createRecord('23b9d861', component.options)
    } else {
      api.reload('23b9d861', component.options)
    }
    module.hot.accept("./EditLabelModal.vue?vue&type=template&id=23b9d861&scoped=true", function () {
      api.rerender('23b9d861', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/fallsFlowManageConfig/fallsFlowManage/components/EditLabelModal.vue"
export default component.exports